export type ComposerDraftScope = {
  actorId: string;
  orgSlug: string;
  threadId?: string | null;
};
export function composerDraftStorageKey(scope: ComposerDraftScope): string {
  return `org-chat-draft:v1:${JSON.stringify([scope.actorId, scope.orgSlug, scope.threadId ?? 'new'])}`;
}
export function serializeComposerDraft(draft: unknown): string {
  return JSON.stringify({ version: 1, draft }, (_key, value) =>
    typeof value === 'string' && value.startsWith('blob:') ? undefined : value
  );
}
/** Browser storage can be unavailable or full; a failed write must not interrupt editing. */
export function writeComposerDraft(
  storage: Pick<Storage, 'setItem'>,
  key: string,
  draft: unknown
): boolean {
  try {
    storage.setItem(key, serializeComposerDraft(draft));
    return true;
  } catch {
    return false;
  }
}
export function readComposerDraft<T>(
  storage: Pick<Storage, 'getItem'>,
  key: string,
  validate: (value: unknown) => value is T
): T | null {
  try {
    const parsed: unknown = JSON.parse(storage.getItem(key) ?? 'null');
    if (
      !parsed ||
      typeof parsed !== 'object' ||
      !('version' in parsed) ||
      parsed.version !== 1 ||
      !('draft' in parsed)
    )
      return null;
    return validate(parsed.draft) ? parsed.draft : null;
  } catch {
    return null;
  }
}
